<template>
	<v-container fluid class="pt-0">
        <v-row align="center" justify="center">
            <v-col cols="12" class="pa-0">
                <v-sheet class="" color="#008dd4" height="7vh"></v-sheet>
            </v-col>
            <v-col cols="12" class="text-center" style="position:relative; margin-top: -60px">
                <v-img v-if="!user.avatar" class="mx-auto" :src="avatar_initial+user.names+avatar_final" style="border-radius: 50%" width="90px"></v-img>
                <h1>Hola, {{ user.names | capitalize }}</h1>
            </v-col>
        </v-row>

        <v-row align="center" justify="center" v-if="pending_validation">
            <v-col lg="6" md="10" sm="12" class="elevation-2 red lighten-2 text-white">
                <h2 class="white--text">¡Espera!</h2>
                <h3 class="white--text">Aún está pendiente de revisión tu comprobante institucional, por lo general esto tarda unos minutos. Es necesario esperar para recibir la bonificación correspondiente. Cuando esté listo, se te notificará vía correo electrónico.</h3>
            </v-col>
        </v-row>

		<v-row justify="center" align="start">
            <v-col lg="5" md="10" sm="12" class="mt-2 px-1 py-1">

                <v-card outlined>
                    <v-app-bar dark color="008dd4">
                        <v-card-title  class="pb-0"><v-icon color="#008dd4" class="mx-1">mdi-bookshelf</v-icon> Mis cursos</v-card-title>
                        <template v-slot:extension>
                            <v-tabs v-model="tabs" align-with-title center-active>
                                <v-tabs-slider color="#fff"></v-tabs-slider>
                                <v-tab v-for="course in courses" :key="course.id">
                                    {{ course.course.language.language }}
                                </v-tab>
                                <v-tab  :key="0">
                                    Agregar Curso
                                </v-tab>
                            </v-tabs>
                        </template>
                    </v-app-bar>
                    <v-tabs-items v-model="tabs">
                        <v-tab-item v-for="course in courses" :key="course.id">
                            <v-card-text>
                                <v-row align="center" justify="center">
                                    <v-col lg="6" md="6" sm="12">

                                        <div class="text-center">
                                            <h2 class="mb-3">{{ course.course.name }} </h2>
                                            <h4>Modalidad : <strong>{{ course.course.modality.name }}</strong></h4>
                                            <h4>Nivel : <strong>{{ course.course.level.name }}</strong></h4>
                                            <h4>Fecha de inicio : <strong>{{ course.course.start_date }}</strong></h4>
                                        </div>
                                    </v-col>
                                    <v-col lg="6" md="6" sm="12">
                                        <v-img src="/images/curso.png" fluid max-width="300" class="mx-auto"></v-img>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-btn block text color="#008dd4" href="/my-courses" tile><strong>Más información</strong></v-btn>
                        </v-tab-item>
                        <v-tab-item>
                            <v-card-text>
                                <v-row align="center" justify="center">
                                    <v-col lg="6" md="6" sm="12">
                                        <div class="text-center" >
                                            <h2 class="mb-3" >Inscribirse a un curso</h2>
                                        </div>

                                    </v-col>
                                    <v-col lg="6" md="6" sm="12">
                                        <v-img src="/images/curso.png" fluid max-width="300" class="mx-auto"></v-img>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-btn  block text color="#008dd4" :href="select_course_url"><strong>Seleccionar curso</strong></v-btn>
                        </v-tab-item>
                    </v-tabs-items>
                    
                    
                </v-card>
                <!--
                <v-card outlined>
                    <v-card-title  class="pb-0"><v-icon color="#008dd4" class="mx-1">mdi-bookshelf</v-icon> Mi curso</v-card-title>
                    <v-card-text>
                        <v-row align="center" justify="center">
                            <v-col lg="6" md="6" sm="12">
                                <div class="text-center" v-if="!course">
                                    <h2 class="mb-3" >Aún no estás inscrito a ningún curso</h2>
                                </div>

                                <div class="text-center" v-else>
                                    <h2 class="mb-3">{{ course.course.name }} {{tab}}</h2>
                                    <h4>Modalidad : <strong>{{ course.course.modality.name }}</strong></h4>
                                    <h4>Nivel : <strong>{{ course.course.level.name }}</strong></h4>
                                    <h4>Fecha de inicio : <strong>{{ course.course.start_date }}</strong></h4>
                                </div>
                            </v-col>
                            <v-col lg="6" md="6" sm="12">
                                <v-img src="/images/curso.png" fluid max-width="300" class="mx-auto"></v-img>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions class="px-0 py-0">
                        <v-btn v-if="!course" block text color="#008dd4" :href="select_course_url"><strong>Seleccionar curso</strong></v-btn>
                        <v-btn v-else block text color="#008dd4" href="/my-courses" tile><strong>Más información</strong></v-btn>
                    </v-card-actions>
                </v-card>
                -->
            </v-col>
            <v-col lg="5" md="10" sm="12" class="mt-2 px-1 py-1">
                <v-card outlined>
                    <v-card-title class="pb-0"><v-icon color="#008dd4" class="mx-1">mdi-account-group</v-icon>Referir amigos</v-card-title>
                    <v-card-text>
                        <v-row align="center" justify="center">
                            <v-col lg="6" md="6" sm="12" class="text-center">
                                <h3 class="mb-4">¡Comparte el enlace a todos tus amigos y obten {{ user.country_code == 'MX' ? '100 pesos' : '6 dolares' }} de descuento en tu próximo pago!*</h3>
                            </v-col>
                            <v-col lg="6" md="6" sm="12">
                                <v-img src="/images/referido.png" fluid max-width="265" class="mx-auto"></v-img>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12 text-center py-0">
                                <small><i>*La promoción se aplicará cuando el referido realice su primer pago de inscripción y mensualidad.</i></small>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions class="px-0 py-0">
                        <v-btn text color="#008dd4" block :loading="loading_referred" @click="referred_link" tile><strong>Copiar enlace</strong></v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col lg="5" md="10" sm="12" class="mt-2 px-1 py-1">
                <v-card outlined>
                    <v-card-title class="pb-0"><v-icon color="#008dd4" class="mx-1">mdi-history</v-icon>Historial</v-card-title>
                    <v-card-text>
                        <v-row align="center" justify="center">
                            <v-col lg="6" md="6" sm="12" class="text-center">
                                <h3>¿Te perdiste tu clase pasada? ¡No te preocupes! Ve la grabación desde el siguiente enlace.</h3>
                                
                            </v-col>
                            <v-col lg="6" md="6" sm="12" class="text-center">
                                <v-img src="/images/historial.png" fluid max-width="200" class="mx-auto"></v-img>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions class="py-0 px-0">
                        <v-btn text color="#008dd4" block href="/my-courses" tile><strong>Ver clase</strong></v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col lg="5" md="10" sm="12" class="mt-2 px-1 py-1">
                <v-card outlined>
                    <v-card-title class="pb-0"><v-icon color="#008dd4" class="mx-1">mdi-currency-usd</v-icon>Balance</v-card-title>
                    <v-card-text>
                        <v-row align="center" justify="center">
                            <v-col lg="6" md="6" sm="12" class="text-center">
                                <h3>Mi balance es: ${{ user.country_code == 'MX' ? balance.balance : balance.dollar_balance }}</h3>
                            </v-col>
                            <v-col lg="6" md="6" sm="12" class="text-center">
                                <v-img src="/images/progreso.png" fluid max-width="250" class="mx-auto"></v-img>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions class="px-0 py-0">
                        <v-btn text color="#008dd4" block href="/payments" tile><strong>Más información</strong></v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog v-model="notification" persistent max-width="600">
            <v-card>
                <v-card-title class="py-1" style="background-color: #ff5252"></v-card-title>
                <v-card-text class="pb-0 pt-3">
                    <v-list-item three-line>
                        <v-list-item-avatar>
                            <v-icon x-large color="error">mdi-alert</v-icon>
                        </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title class="headline">Atención</v-list-item-title>
                        <v-list-item-subtitle class="d-inline-block">
                            Bienvenido a Instituto Neumann, Recuerda que solo tienes 48 horas para realizar tu pago una vez registrado en tu curso para conservar tu lugar en el curso.
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    </v-list-item>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="notification = false">Aceptar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
	</v-container>
</template>
<script>

    import iziToast from 'izitoast'

	export default {
        props:['user','course','courses','balance','pending_validation','referred_url'],
        data: () => ({
            data_url:"/home",
            select_course_url:"/my-courses/select-course",
            loading_referred: false,
            avatar_initial:"https://ui-avatars.com/api/?name=",
            avatar_final:"&background=random&size=90",
            notification:false,
            tabs: null,
            tab: null
        }),

        filters: {
            capitalize: function (value) {
                if (!value) return ''
                value = value.toString()
                return value.charAt(0).toUpperCase() + value.slice(1)
            }
        },

        mounted(){
            this.notification = this.course && !this.course.verified ? true : false
            this.courses.forEach(course => {
                if(!course.verified)
                    this.notification = true 
            });
        },
        

        methods:{
            referred_link: function(){
                this.loading_referred = true

                if (navigator.share) {
                    navigator.share({
                        title: 'Instituto Neumann',
                        text: 'Clases de inglés online',
                        url: this.referred_url,
                    })
                        .then(() => {
                            iziToast.success({
                                title:"Correcto",
                                message:"Enlace copiado correctamente",
                                position:"topRight"
                            })
                        })
                }else{
                    
                    const textarea = document.createElement('textarea');
                    textarea.value = this.referred_url;
                    document.body.appendChild(textarea);
                    textarea.select();
                    document.execCommand('copy');
                    document.body.removeChild(textarea);

                    iziToast.success({
                        title:"Correcto",
                        message:"Enlace copiado correctamente",
                        position:"topRight"
                    })

                }

                this.loading_referred = false
            }
        }
	}
</script>
